/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FixedPriceQuoteTemplateResource } from './';
import {
    FixedPriceQuoteTemplateResourceFromJSON,
    FixedPriceQuoteTemplateResourceFromJSONTyped,
    FixedPriceQuoteTemplateResourceToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteTemplateResource } from './';
import {
    TimeAndMaterialsQuoteTemplateResourceFromJSON,
    TimeAndMaterialsQuoteTemplateResourceFromJSONTyped,
    TimeAndMaterialsQuoteTemplateResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteTemplateResource
 */
export interface QuoteTemplateResource {
    /**
     * 
     * @type {string}
     * @memberof QuoteTemplateResource
     */
    quoteId: string;
    /**
     * 
     * @type {QuoteStatus}
     * @memberof QuoteTemplateResource
     */
    status: QuoteStatus;
    /**
     * 
     * @type {Date}
     * @memberof QuoteTemplateResource
     */
    submissionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof QuoteTemplateResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteTemplateResource
     */
    freelancerTermsAndConditions?: string;
    /**
     * 
     * @type {QuoteType}
     * @memberof QuoteTemplateResource
     */
    type: QuoteType;
    /**
     * 
     * @type {Client}
     * @memberof QuoteTemplateResource
     */
    client: Client;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteTemplateResource
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof QuoteTemplateResource
     */
    totalAmountInclTaxes: number;
}

/**
 * Check if a given object implements the QuoteTemplateResource interface.
 */
export function instanceOfQuoteTemplateResource(value: object): value is QuoteTemplateResource {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('totalAmountInclTaxes' in value) || value['totalAmountInclTaxes'] === undefined) return false;
    return true;
}

export function QuoteTemplateResourceFromJSON(json: any): QuoteTemplateResource {
    return QuoteTemplateResourceFromJSONTyped(json, false);
}

export function QuoteTemplateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteTemplateResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return FixedPriceQuoteTemplateResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteTemplateResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'quoteId': json['quoteId'],
        'status': QuoteStatusFromJSON(json['status']),
        'submissionDate': json['submissionDate'] == null ? undefined : (new Date(json['submissionDate'])),
        'title': json['title'],
        'freelancerTermsAndConditions': json['freelancerTermsAndConditions'] == null ? undefined : json['freelancerTermsAndConditions'],
        'type': QuoteTypeFromJSON(json['type']),
        'client': ClientFromJSON(json['client']),
        'currency': CurrencyFromJSON(json['currency']),
        'totalAmountInclTaxes': json['totalAmountInclTaxes'],
    };
}

export function QuoteTemplateResourceToJSON(value?: QuoteTemplateResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return FixedPriceQuoteTemplateResourceToJSON(value as FixedPriceQuoteTemplateResource);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteTemplateResourceToJSON(value as TimeAndMaterialsQuoteTemplateResource);
        }
    }
    return {
        
        'quoteId': value['quoteId'],
        'status': QuoteStatusToJSON(value['status']),
        'submissionDate': value['submissionDate'] == null ? undefined : ((value['submissionDate']).toISOString()),
        'title': value['title'],
        'freelancerTermsAndConditions': value['freelancerTermsAndConditions'],
        'type': QuoteTypeToJSON(value['type']),
        'client': ClientToJSON(value['client']),
        'currency': CurrencyToJSON(value['currency']),
        'totalAmountInclTaxes': value['totalAmountInclTaxes'],
    };
}

